/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/no-named-as-default */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import "./select.scss";
import t from "../../../utils/translation/translator";

/**
 * Select
 */
const Select = ({
  label,
  id,
  disabled,
  labelPosition,
  required,
  error,
  options,
  onSelect,
  initValue,
  changeWithInit,
  ...props
}) => {
  const [value, setValue] = useState(initValue);

  useEffect(() => {
    if (changeWithInit) {
      setValue(initValue);
    }
  }, [initValue]);

  return (
    <div className={`space-y-2 select-container${labelPosition === "top" ? " top" : ""}`} {...props}>
      <label
        className={` text-xs flex items-center justify-between select-label${
          labelPosition === "top" ? " top" : " left"
        }`}
        htmlFor={`select-${id}`}
      >
        <div className="space-x-1">
          <span>{label}</span>
          {required && <span className="text-red-500">*</span>}
        </div>
        {error && <span className="text-red-500 text-xxs">{t("msizer.ui.mandatory_field_missing")}</span>}
      </label>
      <select
        required={required}
        className={`select border-[1px] border-gray-400 w-full py-1 px-2 text-xs text-gray-500 ${
          error ? " border-red-500" : ""
        }`}
        id={`select-${id}`}
        disabled={disabled}
        onChange={(val) => {
          console.log(val.target.value);
          onSelect(val.target.value);
          setValue(val.target.accessKeyLabel);
        }}
        value={value}
      >
        {options.map((option) => (
          <option
            className={`${option.disabled ? "text-gray-300" : ""}`}
            value={option.key}
            key={option.key}
            disabled={option.disabled}
            style={option.style}
          >
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

Select.propTypes = {
  /**
   * Label displayed around the select
   */
  label: PropTypes.node.isRequired,
  /**
   * Can we interact with the select?
   */
  disabled: PropTypes.bool,
  /**
   * Location of the select label:
   * top for top left of the picker,
   * left for the left of the picker,
   * none for no label
   */
  labelPosition: PropTypes.oneOf(["top", "left", "none"]),
  /**
   * id of the select, which will be named "select-[id]".
   * id must be unique in order for the select to work correctly.
   * id must contain only letters and -
   */
  id: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.exact({
      label: PropTypes.string.isRequired,
      key: PropTypes.node.isRequired,
      disabled: PropTypes.bool,
      style: PropTypes.object
    })
  ).isRequired,
  required: PropTypes.bool,
  error: PropTypes.bool,
  onSelect: PropTypes.func,
  initValue: PropTypes.string,
  changeWithInit: PropTypes.bool
};

Select.defaultProps = {
  disabled: false,
  labelPosition: "top",
  required: false,
  error: false,
  onSelect: () => {},
  initValue: "",
  changeWithInit: true
};

export default Select;
